import { Component, inject, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@core/models/common.model';
import { Observable } from 'rxjs';
import { DIALOG_DATA, DialogRef } from '@shared/ui/dialog.service';
import { SnackBarService } from '@shared/ui/snack-bar.service';

export interface Patient {
  id: string;
  code: string;
  name: string;
  contactNumber: string;
  email?: string;
  dateOfBirth?: string;
  gender?: string;
}

@Component({
  selector: 'app-patient-search-dialog',
  templateUrl: './patient-search-dialog.component.html',
  styleUrl: './patient-search-dialog.component.css',
  standalone: false,
})
export class PatientSearchDialogComponent {
  private readonly dialogRef = inject(DialogRef<PatientSearchDialogComponent>);
  private readonly snackBar = inject(SnackBarService);
  private readonly http = inject(HttpClient);

  searchText = '';
  filteredPatients: Patient[] = [];
  isSearching = false;
  displayedColumns = ['name', 'code', 'contactNumber', 'action'];

  handleSearch(): void {
    if (!this.searchText.trim()) {
      this.snackBar.open('Please enter a search term', 'Close', { duration: 2000 });
      return;
    }

    this.isSearching = true;
    this.searchPatients(this.searchText).subscribe({
      next: (response) => {
        if (response.success && Array.isArray(response.data)) {
          this.filteredPatients = response.data;
          if (this.filteredPatients.length === 0) {
            this.snackBar.open('No patients found', 'Close', { duration: 2000 });
          }
        } else {
          this.filteredPatients = [];
        }
        this.isSearching = false;
      },
      error: (error) => {
        console.error('Search failed:', error);
        this.filteredPatients = [];
        this.isSearching = false;
        this.snackBar.open('Search failed', 'Close', { duration: 2000 });
      },
    });
  }

  selectPatient(patient: Patient): void {
    this.dialogRef.close(patient);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  private searchPatients(searchTerm: string): Observable<ApiResponse<Patient[]>> {
    return this.http.get<ApiResponse<Patient[]>>(
      `${environment.apiBaseUrl}/Patient/search/${encodeURIComponent(searchTerm)}`
    );
  }
}
